<template>
    <page no-styling>
      <div class="card slightly_yellow_background" style="padding: 0;">
        <!-- setting width in the style, so aspect ratio stays the same-->
        <edit-image
          v-model="user.image.url"
          :callback="setUrlToUser"
          image-class="user_image"
          :width="350"
          :height="350"
          style="width: 100%"
        />
        <form class="flex column px2 py4" @submit.prevent="updateProfile">
          <input
            class="box grow"
            id="fullName"
            name="fullName"
            v-validate="'required'"
            v-model="user.fullName"
            type="text"
            :placeholder="$t('cms.editProfile.FullName')"
            :class="{ 'error': errors.has('name') }"
          >
          <input
            class="flex grow box my1 disabled-input"
            id="email"
            name="email"
            :value="user.email"
            type="email"
            :disabled="true"
          >
          <button
            type="submit"
            :disabled="!isDifferent"
            class="box primary block"
          >
            {{ $t('cms.campaign.saveButton') }}
          </button>
        </form>
      </div>
    </page>
</template>

<script>
import pick from 'lodash/pick';
import store from '@/store';
import EditImage from '@/components/EditImage.vue';
import { objectIsDifferent } from '@/utils/difference';
import AuthMixin from '@/mixins/auth_mixin';

export default {
  components: {
    EditImage,
  },
  mixins: [AuthMixin],
  data() {
    return {
      url: '',
      user: pick(store.state.user, ['id', 'fullName', 'email', 'image']),
      savedData: pick(store.state.user, ['id', 'fullName', 'email', 'image']),
      imageInput: null,
    };
  },

  computed: {
    isDifferent() {
      return objectIsDifferent(
        this.savedData, this.user,
      ) || !!this.imageInput;
    },
  },

  created() {
    if (!this.user.image) {
      this.user.image = {};
    }
  },

  methods: {
    setUrlToUser(url) {
      this.imageInput = {
        url,
        imageOfUser: this.user.id,
        ownedByOrganization: store.state.organization.id,
      };
    },

    saveUrlToUser() {
      if (this.imageInput) {
        this.$mutate(this.$mutations.createImage, { input: this.imageInput });
      }
    },

    async updateProfile() {
      await this.$validator.validate();
      const errors = await this.errors.all();
      if (errors.length > 0) {
        errors.forEach(this.showWarningNotification);
        return null;
      }

      const { errors: requestErrors } = await this.$mutate(
        this.$mutations.editProfile, { fullName: this.user.fullName },
      );

      if (requestErrors.length > 0) {
        requestErrors.forEach(this.showWarningNotification);
        return null;
      }

      this.saveUrlToUser();

      this.savedData = {
        id: this.user.id,
        fullName: this.user.fullName,
        image: this.user.image,
        email: this.user.email,
      };

      this.setState();
      this.imageInput = null; // so isDifferent doesn't return true anymore
      return null;
    },
  },
};
</script>
